import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import amplitude from "../utils/amplitude";
import { useUser } from "../context/useInfo";

const KeepResults = () => {
  const [email, setEmail] = useState("");
  const {updateUserData} = useUser();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {


            if(process.env.NODE_ENV === "production"){
                amplitude.track('Keep Results Open');
            }
  }, [])

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const subscribeUser = async (email) => {
    setIsSubmitting(true); // Добавить эту строку
    try {
        const res = await fetch("https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/addUserToMailchimp", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa("quiz_admin:s*Q&FLx^9BUQ"),
     },
          body: JSON.stringify({ email }),
          });
            if(process.env.NODE_ENV === "production"){
                amplitude.track('Keep Results Next Click');
            }
          const data = await res.json();
          if (!res.ok) {
          console.error("Error subscribing:", data.error);
          } else {
          updateUserData({ email: email });
          }
          localStorage.setItem("email", email )
          navigate("/prediction")
            setTimeout(() => {
            window.scrollTo(0, 0);
          }, 0);
        
    } catch (error) {
        console.log("Error:", error)
    }
    };


      const valid = isValidEmail(email);
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <img
        src="/letter.png" // замените на путь к вашей галочке
        alt="Done"
        className="w-40 h-40 mb-6"
      />
      <h1 className="text-3xl font-bold text-pink-500 mb-2">
        Keep your results
      </h1>
      <p className="text-center text-gray-500 mb-3">
        To ensure that the results are<br/> saved in your account
      </p>

      {/* Поле для email */}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-[350px] max-w-md p-4 border border-gray-300 rounded-full mb-4 focus:outline-none focus:ring-2 focus:ring-pinkCustom"
      />

      {/* Кнопка отправки */}
<button
  onClick={() => subscribeUser(email)}
  disabled={!valid || isSubmitting}
  className={`w-[350px] max-w-md py-4 mb-4 rounded-full transition
    ${valid && !isSubmitting ? "bg-pinkCustom text-white hover:bg-pink-600" : "bg-gray-300 text-gray-500 cursor-not-allowed"}
  `}
>
  {isSubmitting ? (
    <span className="flex items-center justify-center">
      Confirming your email
      <span className="flex space-x-1 ml-1">
        <span className="animate-sequential-fade">.</span>
        <span className="animate-sequential-fade" style={{ animationDelay: '0.4s' }}>.</span>
        <span className="animate-sequential-fade" style={{ animationDelay: '0.8s' }}>.</span>
      </span>
    </span>
  ) : (
    "Next"
  )}
</button>
      <p className="text-center text-gray-500 mb-3 text-xs">
        Your information is 100% secure. Solvi does not share your<br/> personal
        information with third parties.
      </p>

      <p className="text-center text-gray-500 mb-3 text-xs">
        By submitting your email address, you may also receive email<br/> offers from
        Solvi about our services. You may unsubscribe at<br/> any time.<br />
        <a
                  href="/privacy-policy"
                  className="text-pink-600 underline hover:text-pink-700"
                >
                  Privacy Policy
                </a>
                ,{" "}
                <a
                  href="/terms-of-use"
                  className="text-pink-600 underline hover:text-pink-700"
                >
                  Terms of Use
                </a>
                , and{" "}
                <a
                  href="/refund-policy"
                  className="text-pink-600 underline hover:text-pink-700"
                >
                  Refund Policy
                </a>
      </p>
    </div>
  );
};

export default KeepResults;
